import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const { login } = useAuth();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(password);
    } catch (err) {
      setError(err.response?.data?.error || 'Invalid password');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page login-page-hangfire">
      <div className="login-glass login-card-hangfire">
        <div className="login-lock-wrap">
          <svg className="login-lock-icon" width="36" height="36" viewBox="0 0 24 24" fill="none" aria-hidden>
            <path
              d="M12 2a5 5 0 00-5 5v3H6a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2v-8a2 2 0 00-2-2h-1V7a5 5 0 00-5-5zm-3 8V7a3 3 0 116 0v3H9z"
              fill="currentColor"
              fillOpacity="0.9"
            />
          </svg>
        </div>
        <h1 className="login-title-hangfire">DB Manager</h1>
        <p className="login-sub-hangfire">
          Use the developer or admin password — admin unlocks the Logs tab
        </p>
        <form onSubmit={handleSubmit} className="login-form-hangfire">
          <input
            type="password"
            className="login-password-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            autoFocus
            autoComplete="current-password"
            required
          />
          {error && <div className="error-msg error-msg-compact">{error}</div>}
          <button type="submit" className="btn btn-primary btn-full btn-unlock" disabled={loading}>
            {loading ? 'Unlocking…' : 'Unlock'}
          </button>
        </form>
      </div>
    </div>
  );
}
